import { motion } from "framer-motion";
import "../styles/toolStyling/Reveal.css";

// Direction-based movement with fade-in
// Added transition for smooth effect
const variants = {
  top: {
    hidden: { opacity: 0, y: -50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  },
  bottom: {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  },
  left: {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  },
  right: {
    hidden: { opacity: 0, x: 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  },
};

export function Reveal({ direction, children }) {
  return (
    <motion.span variants={variants[direction]} className="reveal-item">
      {children}
    </motion.span>
  );
}
